import { t } from '@citrite/translate';
import $ from 'jquery';

export class ChangePasswordWidget {
	private $container: JQuery;

	public constructor($containerElement: JQuery) {
		this.$container = $containerElement;
	}

	public showPasswordExpiryMessage(
		daysUntilExpiration: number,
		options: Partial<typeof defaultOptions>
	) {
		const defaultOptions = {
			onContinue() {},
			onChange() {},
		};

		options = $.extend({}, defaultOptions, options);
		this.setMessageText(this.getExpirationText(daysUntilExpiration));

		// Add the button actions
		const $changeButton = this.$container.find('#btnPasswordChange');
		const $continueButton = this.$container.find('#btnPasswordContinue');
		//Enable the buttons if they are disabled
		$changeButton.prop('disabled', false);
		$continueButton.prop('disabled', false);
		$changeButton.on('click', function (event) {
			event.preventDefault();
			if (!$changeButton.prop('disabled')) {
				options.onChange();
				$changeButton.prop('disabled', true);
			}
		});
		$continueButton.on('click', function (event) {
			event.preventDefault();
			if (!$continueButton.prop('disabled')) {
				options.onContinue();
				$continueButton.prop('disabled', true);
			}
		});

		$changeButton.focus();

		this.$container.on('keydown', function (e) {
			if (e.keyCode === 27 /* escape */) {
				$continueButton.click();
			}
		});
	}

	private getExpirationText(daysUntilExpiration: number) {
		switch (daysUntilExpiration) {
			case 0:
				return t('Workspace:login.expires_today');
			case 1:
				return t('Workspace:login.expires_tomorrow');
			default:
				return t('Workspace:login.expires_days', {
					days: daysUntilExpiration,
				});
		}
	}

	private setMessageText(messageText: string) {
		this.$container.find('.authentication-message').text(messageText);
	}
}
